import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  path?: any[];
}

@Injectable({ providedIn: 'root' })
export class LayoutStateService {

  private readonly _sidebarVisible = new BehaviorSubject<boolean>(true);
  readonly sidebarVisible$ = this._sidebarVisible.asObservable();

  private readonly _breadcrumbs = new BehaviorSubject<BreadcrumbItem[]>([]);
  readonly breadcrumbs$ = this._breadcrumbs.asObservable();

  setSidebarVisible(visible: boolean): void {
    this._sidebarVisible.next(visible);
  }

  setBreadcrumbs(items: BreadcrumbItem[]): void {
    this._breadcrumbs.next(items);
  }
}
